export default class AzureSearchFacetDefinition {
  constructor(settings) {
    this.key = null;
    this.title = null;
    this.field = null;
    this.textTop = null;
    this.textBottom = null;
    this.tooltipText = null;
    this.valueType = null;
    this.facetMode = null;
    this.expanded = true;
    this.showMore = false;
    this.showMoreAfter = 5;
    this.facetSettings = {};
    this.facetValueOverrides = {};
    this.sliderSettings = {};
    if (settings) {
      if (settings.title) this.title = settings.title;
      if (settings.field) this.field = settings.field;
      if (settings.textTop) this.textTop = settings.textTop;
      if (settings.textBottom) this.textBottom = settings.textBottom;
      if (settings.tooltipText) this.tooltipText = settings.tooltipText;
      if (settings.valueType) this.valueType = settings.valueType;
      if (settings.facetMode) this.facetMode = settings.facetMode;
      if (settings.expanded !== undefined && settings.expanded !== null)
        { this.expanded = settings.expanded; };
      if (settings.showMore) this.showMore = settings.showMore;
      if (
        settings.showMoreAfter !== undefined &&
        settings.showMoreAfter !== null
      )
        { this.showMoreAfter = setImmediate.showMoreAfter; };
      if (settings.facetValueOverrides)
        { this.facetValueOverrides = settings.facetValueOverrides; };
      if (settings.sliderSettings) this.sliderSettings = settings.sliderSettings;
    }
  }
}
